import React from "react";
import { processImagePath } from "../util/Functions";
import "./PWA.scss";

export default function PWA() {
	const currentUserInfo = JSON.parse(localStorage.getItem('organization_member:data'));
	const [deferredPrompt, setDeferredPrompt] = React.useState(null);
	const [isInstalled, setIsInstalled] = React.useState(window.matchMedia('(display-mode: standalone)').matches);
	const [isReady, setIsReady] = React.useState(false);

	React.useEffect(() => {
		if (!navigator?.serviceWorker || !currentUserInfo) {
			return;
		}

		// Pull dynamic manifest from the CDN
		// This is a workaround for the fact that we can't use a dynamic manifest
		// in the service worker, so we have to load it here and then use it.
		const link = document.createElement('link');
		link.rel = "manifest";
		link?.setAttribute(
			"href",
			"https://cdn.bosslogics.live/manifest/organization.php?id="
			+ currentUserInfo?.organization?.id + "&platform=catalog&"
			+ Math.random()
		);
		document.head.appendChild(link);

		navigator.serviceWorker
			.register("/js/service-worker.js")
			.then(() => { }).catch(() => { });
		
		const handleBeforeInstallPrompt = e => {
			e.preventDefault();
			setDeferredPrompt(e);
			setIsReady(true);
		};
		
		const handleAppInstalled = () => setIsInstalled(true);
		
		window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
		window.addEventListener('appinstalled', e => {
			localStorage.removeItem("pwa_dismissed");
			// hide install message on install so resulting screen doesn't still show it
			document.addEventListener("visibilitychange", () => {
				document.querySelector("[data-component='PWA']")?.remove();
			}, { once: true });
		});
		
		return () => {
			window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
			window.removeEventListener('appinstalled', handleAppInstalled);
		};
	}, []);

	if (!navigator?.serviceWorker || !currentUserInfo) {
		return null;
	}

	const org = currentUserInfo?.organization;
	const parent = org?.parent;
	const name = (org?.name || parent?.name)?.split("(")[0] || "BOSS";
	const icon = org?.icon || parent?.icon || org?.logo || parent?.logo
		|| 'https://cdn.bosslogics.live/manifest/images/logos/pwa/manifest-icon-192.maskable.png';

	const pwaDismissed = localStorage.getItem("pwa_dismissed") === "true";
	const pwaInstalled = localStorage.getItem("pwa_installed") === "true";
	if (pwaInstalled || pwaDismissed || isInstalled || !isReady) {
		return null;
	}

	const install = async () => {
		if (deferredPrompt) {
			deferredPrompt.prompt();
			const { outcome } = await deferredPrompt.userChoice;
			if (outcome === 'accepted') {
				setDeferredPrompt(null);
			}
		}
	};
	const dismiss = () => {
		localStorage.setItem("pwa_dismissed", "true");
		document.querySelector("[data-component='PWA']").remove();
	};


	const iconNode = (icon && (
		<div className="icon">
			<img
				src={processImagePath(icon)}
				alt="PWA Icon"
				className="icon"
				width="100%"
				height="100%"
			/>
		</div>
	));

	return (
		<div data-component="PWA">
			{iconNode}
			<div className="inner">
				<div className="text">
					<h2>{name} App</h2>
					<p>Install for a faster and sleeker experience.</p>
				</div>
				<div className="cta">
					<button className="dismiss" onClick={dismiss}>Not Now</button>
					<button className="install" onClick={install}>Install</button>
				</div>
			</div>
		</div>
	)
}